module.exports = __webpack_public_path__ + "img/panelView_3_3.c6305ddd.png";